import * as React from "react";
import { markdown, ReactSpecimen } from "catalog";
import { Accordion } from "./Accordion";
import { TagList } from "./TagList";
import { LinkButton } from "./Controls";
import { Small } from "../theme/text";
const sampleTagItems = [
    { label: "Lorem ipsum", "@id": "foo", "@type": "Dimension" },
    { label: "dolor sit amet", "@id": "foo2", "@type": "Dimension" },
    { label: "adipisicing", "@id": "foo3", "@type": "Topic" },
    { label: "Eum ipsam cupiditate", "@id": "foo4", "@type": "Dimension" },
    { label: "quibusdam commodi", "@id": "foo5", "@type": "Topic" },
    { label: "ducimus esse sint", "@id": "foo6", "@type": "Dimension" },
    { label: "error accusantium", "@id": "foo8", "@type": "Time" },
    { label: "labore reprehenderit", "@id": "foo7", "@type": "Location" }
];
class AccordionDocs extends React.Component {
    constructor(props) {
        super(props);
        this.onAccordionLabelClick = (e) => {
            this.setState({
                active: e.currentTarget.value
            });
        };
        this.state = {
            active: "Tags",
            showModal: false,
            switchModal: 0
        };
    }
    render() {
        return (<div style={{ width: "300px" }}>
        <Accordion items={[
            {
                label: "Tags",
                content: (<React.Fragment>
                  <TagList showTitles={false} tags={sampleTagItems}/>
                </React.Fragment>)
            },
            {
                label: "Quellen",
                content: (<React.Fragment>
                  <LinkButton text="1901-1941: Personenmeldeamt der Stadt Zürich" icon="Externallink" href="#"/>
                  <LinkButton text="1942-2017: Statistisches Amt des Kanton Zürich" icon="Externallink" href="#"/>
                  <LinkButton text="1942-2017: Bundesamt für Statistik" icon="Externallink" href="#"/>
                </React.Fragment>)
            },
            {
                label: "Glossar",
                content: (<React.Fragment>
                  <LinkButton text="Bevölkerung" icon="Info" href="#"/>
                  <LinkButton text="Bevölkerungsbestand" icon="Info" href="#"/>
                </React.Fragment>)
            },
            {
                label: "Erhebungsmethode",
                content: (<React.Fragment>
                  <Small>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </Small>
                </React.Fragment>)
            }
        ]} active={this.state.active} onAccordionLabelClick={this.onAccordionLabelClick}/>
      </div>);
    }
}
export default () => markdown `

## Accordion

The accordion component is used on the detail page to provide metadata for the dataset being displayed.

${(<ReactSpecimen>
    <AccordionDocs />
  </ReactSpecimen>)}
`;



// WEBPACK FOOTER //
// ./src/components/Accordion.docs.tsx